import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';

export const BrandingLogo = (props) => {
  const { sx, ...imgProps } = props;
  const hasHeight = imgProps.height != null && imgProps.height !== '';

  return (
    <Box
      component={Link}
      to='/'
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        lineHeight: 0,
        flexShrink: 0,
        // Wide assets stay huge at fixed height (100%) — cap width on all breakpoints
        maxWidth: {
          xs: 'min(160px, 46vw)',
          sm: 'min(200px, 40vw)',
          md: 200,
          lg: 220,
        },
        ...sx,
      }}
    >
      <Box
        component='img'
        alt='logo'
        src='https://shopicar-images.s3.amazonaws.com/0/shopitradeBlack.png'
        {...imgProps}
        sx={{
          display: 'block',
          width: 'auto',
          maxWidth: '100%',
          objectFit: 'contain',
          ...(hasHeight
            ? { height: imgProps.height }
            : {
                height: 'auto',
                maxHeight: { xs: 40, sm: 48 },
              }),
        }}
      />
    </Box>
  );
};
